<template>
  <v-container v-if="currentHour !== undefined">
    <v-row>
      <v-col v-for="(question, i) in openQuestions" :key="i" xl="3" lg="4" md="6" sm="12">
        <template v-if="question.text !== ''">
        <v-row>
          <v-col sm="10">
              <h2 class="d-inline">Q{{ question.questionNumber }}</h2>
              <h3 class="d-inline one-done" v-if="question.oneDone">One & Done</h3>
              <div class="question-text body-1 d-inline">{{ question.text }}</div>
          </v-col>
          <v-col sm="2">
            <v-btn color="primary"
                   v-if="hasDeletedSubmissions(question.questionNumber)"
                   x-large
                   flat
                   icon
                   @click="clearDeletedSubmissions(getSubmissions(question.questionNumber))">
              <v-icon>mdi-delete-sweep</v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-row class="fishing-guess" v-if="!question.oneDone">
          <v-col xl="7" lg="7" md="7" sm="7">
            <v-text-field
              :label="'Q' + question.questionNumber + ' New Submission'"
              v-model="fishingGuesses[question.questionNumber]"
              placeholder="Guess"
              outlined
              dense
            ></v-text-field>
          </v-col>
          <v-col  xl="5" lg="5" md="5" sm="5" class="text-right">
            <v-btn-toggle>
              <v-btn small class="ans-btn" color="error" @click="fishingWrong(openQuestions[i], fishingGuesses[question.questionNumber])" dark>w</v-btn>
              <v-btn small class="ans-btn" color="primary" @click="fishingNote(openQuestions[i], fishingGuesses[question.questionNumber], true)" dark>p</v-btn>
              <v-btn small class="ans-btn" color="success" @click="fishingCorrect(openQuestions[i], fishingGuesses[question.questionNumber])" dark>c</v-btn>
              <v-btn small class="ans-btn" color="grey-lighten-4" @click="fishingNote(openQuestions[i], fishingGuesses[question.questionNumber], false)" dark>N</v-btn>
            </v-btn-toggle>
<!--            <v-btn x-small light @click="fishingNote(openQuestions[i], fishingGuesses[question.questionNumber], false)">Note</v-btn>-->
          </v-col>
        </v-row>
        <v-simple-table>
          <template v-slot:default>
            <thead hidden>
            <tr>
              <th>#</th>
              <th>Researcher</th>
              <th>Answer</th>
              <th>A</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(sub, index) in getSubmissions(question.questionNumber)" :key="index" :quest="question">
              <td>{{ sub.sureness }}</td>
              <td v-if="sub.submittedBy.length<=8">{{ sub.submittedBy }}</td>
              <td v-else>{{ sub.submittedBy.substring(0,7)+".." }}</td>
              <td :class="submissionFormat(sub)">{{ sub.text }}</td>
              <td align="right" v-if="!question.oneDone">
                <v-btn-toggle v-if="!sub.calledInBy">
                  <v-btn small class="ans-btn" color="error" @click="wrong(openQuestions[i], sub)" dark>w</v-btn>
                  <v-btn small class="ans-btn" color="primary" @click="partial(openQuestions[i], sub)" dark>p</v-btn>
                  <v-btn small class="ans-btn" color="success" @click="correctAnswer(openQuestions[i], sub)" dark>c</v-btn>
                </v-btn-toggle>
                <span v-else>{{ sub.calledInBy }}</span>
              </td>
            </tr>
            </tbody>
          </template>
        </v-simple-table>
        <template v-if="getPartials(question.questionNumber)">
          <h3 class="partial-title">Notes</h3>
          <v-simple-table>
            <thead>
            <tr hidden>
              <th>Text</th>
              <th>Submitter</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(sub, index) in getPartials(question.questionNumber)" :key="index" :quest="question">
              <td class="answer-text">
                <v-chip small v-if="sub.partial" color="primary" :label="true" :append="true">partial</v-chip>
                <span v-html="linkify(sub.text)"></span>
              </td>
              <td>{{ sub.submittedBy }}</td>
            </tr>
            </tbody>
          </v-simple-table>
        </template>
        <template v-if="!question.oneDone">
          <div>
            <v-menu offset-x>
              <template v-slot:activator="{ on }">
                <v-btn class="fishing-list" small color="cyan darken-2" dark v-on="on">
                  Add List
                </v-btn>
              </template>
              <v-list>
                <v-list-item v-for="(list, index) in fishingLists" :key="index" @click="addList(question, list)">
                  <v-list-item-title>{{ list.listName }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </template>
        </template>
      </v-col>
    </v-row>
    <template>
      <v-row justify="center">
        <v-dialog v-model="correctDialog" persistent max-width="600px">
          <v-card>
            <v-card-title>
              <span class="headline">Correct Answer</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="6" md="6">
                    <v-text-field label="Submitted By" v-model="proposedSolution.submittedBy" outlined></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <v-text-field label="Points" v-model="selectedQuestion.pointValue" outlined></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-textarea label="Answer" name="answer" v-model="proposedSolution.text" outlined rows="8" cols="20" />
                  </v-col>
                  <v-col cols="12">
                    <v-text-field label="Phone Bank Worker"
                                  v-model="phoneBankWorker"
                                  autofocus outlined required>
                    </v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="warning lighten-2" text @click="resetCorrectDialog()">Close</v-btn>
              <v-btn color="primary" @click="correct(selectedQuestion, proposedSolution, phoneBankWorker)">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>
    <template>
      <v-row justify="center">
        <v-dialog v-model="partialDialog" persistent max-width="600px">
          <v-card>
            <v-card-title>
              <span class="headline">Partial</span>
            </v-card-title>
            <v-card-text>
              <v-container light>
                <v-row v-for="(word, i) in partialWords" :key="i">
                  <v-col cols="4">
                      <span class="title partial-word">{{ word.text }}</span>
                  </v-col>
                  <v-col cols="8">
                      <v-radio-group v-model="word.selection" row>
                        <v-radio label="Partial" value="partial" color="primary"></v-radio>
                        <v-radio label="Wrong" value="wrong" color="red"></v-radio>
                        <v-radio label="Re-submit" value="resubmit" color="green "></v-radio>
                      </v-radio-group>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="warning lighten-2" text @click="resetPartialDialog()">Close</v-btn>
              <v-btn color="primary" @click="processPartials(selectedQuestion, partialWords)">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>
  </v-container>
  <v-container v-else>
    <v-skeleton-loader type="table" />
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import { sortBy, orderBy, map, forEach } from 'lodash'
import { structuredClone } from 'core-js'

export default {
  name: 'CallerPage',
  data () {
    return {
      correctDialog: false,
      partialDialog: false,
      proposedSolutionId: '',
      proposedSolution: {},
      phoneBankWorker: '',
      selectedQuestion: {},
      partialWords: [],
      fishingGuesses: {},
    }
  },
  computed: {
    currentHour: function () {
      return this.$store.getters['currentHour/hourNumber']
    },
    openQuestions: function () {
      return this.$store.getters['questions/openQuestionsForHour'](this.currentHour)
    },
    answersForHour: function () {
      return this.$store.getters['answers/getAnswersForHour'](this.currentHour)
    },
    fishingLists: function () {
      return this.$store.getters['fishing/getLists']()
    },
    ...mapState({
      me: state => state.me,
    }),
  },
  mounted: async function () {
    await this.$store.dispatch('currentHour/bindCurrent')
    await this.$store.dispatch('questions/bindHourQuestions', this.currentHour)
    await this.$store.dispatch('answers/bindHourAnswers', this.currentHour)
    await this.$store.dispatch('fishing/bindLists')
  },
  watch: {
    currentHour: function () {
      this.$store.dispatch('answers/bindHourAnswers', this.currentHour)
      this.$store.dispatch('questions/bindHourQuestions', this.currentHour)
    },
  },
  methods: {
    getSubmissions: function (questionNumber) {
      if (!this.answersForHour || !this.answersForHour[`question${questionNumber}`]) {
        return []
      }
      return sortBy(this.answersForHour[`question${questionNumber}`].submissions, 'sureness')
    },
    getPartials: function (questionNumber) {
      if (!this.answersForHour || !this.answersForHour[`question${questionNumber}`]) {
        return []
      }
      let notesWithKey = map(this.answersForHour[`question${questionNumber}`].notes, (item, key) => ({ ...item, _key: key }))
      // Filter out irrelevant notes
      let filteredNotes = notesWithKey.filter(note => note.relevance < 3)
      return orderBy(filteredNotes, ['relevance'], ['asc'])
    },
    linkify: function (text) {
      const regex = /(https?:\/\/[^\s/$.?#].[^\s]*)/gm
      let replacement = text.replace(regex, '<a href="$1" target="blank">$1</a>')
      return replacement
    },
    correctAnswer: function (question, answer) {
      this.correctDialog = true
      this.proposedSolution = answer
      this.selectedQuestion = question
    },
    correct: function (question, answer, phoneBankWorker) {
      answer.calledInBy = this.me.username
      answer.phoneBankWorker = phoneBankWorker
      let submission = {
        hourNumber: question.hourNumber,
        questionId: question.id,
        answer: answer,
      }
      this.$store.dispatch('answers/correct', submission).then(this.resetCorrectDialog)
    },
    resetCorrectDialog: function () {
      this.correctDialog = false
      this.proposedSolution = {}
      this.phoneBankWorker = ''
      this.questionPointValue = 0
    },
    wrong: function (question, answer) {
      answer.calledInBy = this.me.username
      let submission = {
        hourNumber: question.hourNumber,
        questionNumber: question.questionNumber,
        answer: answer,
      }
      this.$store.dispatch('answers/addToIncorrects', submission)
      this.$store.dispatch('answers/markForDeletion', submission)
    },
    partial: function (question, answer) {
      this.selectedQuestion = question
      this.proposedSolution = answer
      let words = answer.text.split(' ')
      if (words.length === 1) {
        answer.partial = true
        answer.relevance = 0
        answer.calledInBy = this.me.username
        let submission = {
          hourNumber: question.hourNumber,
          questionNumber: question.questionNumber,
          answer: answer,
        }
        let submissionCopy = structuredClone(submission)
        this.$store.dispatch('answers/addNote', submissionCopy)
        this.$store.dispatch('answers/markForDeletion', submission)
      } else {
        words.forEach((word) => {
          this.partialWords.push({ text: word, selection: 'resubmit' })
        })
        this.partialDialog = true
      }
    },
    processPartials: function (question, partial) {
      let submission = {
        hourNumber: question.hourNumber,
        questionNumber: question.questionNumber,
        answer: this.proposedSolution,
      }
      let submissionCopy = structuredClone(submission)

      submission.answerId = this.proposedSolutionId
      submission.answer.calledInBy = this.me.username
      this.$store.dispatch('answers/addToIncorrects', submission)
      this.$store.dispatch('answers/markForDeletion', submission)

      partial.forEach((word) => {
        submissionCopy.answer.text = word.text
        if (typeof submissionCopy.answer.partial !== 'undefined') {
          delete submissionCopy.answer.partial
        }
        if (word.selection === 'resubmit') {
          submissionCopy.answer.sureness = 0
          this.$store.dispatch('answers/add', submissionCopy)
        } else if (word.selection === 'partial') {
          submissionCopy.answer.partial = true
          submissionCopy.answer.relevance = 0
          this.$store.dispatch('answers/addNote', submissionCopy)
        } else if (word.selection === 'wrong') {
          this.$store.dispatch('answers/addToIncorrects', submissionCopy)
        }
      })
      this.resetPartialDialog()
    },
    resetPartialDialog: function () {
      this.partialWords = []
      this.partialDialog = false
    },
    addList: function (question, list) {
      forEach(list.items, (o) => {
        this.fishingSubmission(question, o)
      })
    },
    fishingWrong: function (question, text) {
      if (!text) return
      let submission = {
        questionNumber: question.questionNumber,
        hourNumber: this.currentHour,
        answer: {
          text: text,
          sureness: 'note',
          submittedBy: this.me.username,
          hourNumber: question.hourNumber,
          questionNumber: question.questionNumber,
          relevance: 1,
          calledInBy: this.me.username,
        },
      }
      this.$store.dispatch('answers/addToIncorrects', submission)
      this.fishingGuesses[question.questionNumber] = ''
    },
    fishingNote: function (question, text, isPartial) {
      if (!text) return
      let submission = {
        questionNumber: question.questionNumber,
        hourNumber: this.currentHour,
        answer: {
          text: text,
          sureness: 'note',
          submittedBy: this.me.username,
          hourNumber: question.hourNumber,
          questionNumber: question.questionNumber,
          relevance: 1,
          partial: isPartial,
        },
      }
      this.$store.dispatch('answers/addNote', submission)
      this.fishingGuesses[question.questionNumber] = ''
    },
    fishingCorrect: function (question, text) {
      let answer = {
        text: text,
        sureness: 3,
        submittedBy: this.me.username,
        hourNumber: question.hourNumber,
        questionNumber: question.questionNumber,
      }
      this.correctAnswer(question, answer)
      this.fishingGuesses[question.questionNumber] = ''
    },
    fishingSubmission: function (question, text) {
      let submission = {
        questionNumber: question.questionNumber,
        hourNumber: this.currentHour,
        answer: {
          text: text,
          sureness: 4,
          submittedBy: this.me.username,
          hourNumber: question.hourNumber,
          questionNumber: question.questionNumber,
        },
      }
      this.$store.dispatch('answers/add', submission)
    },
    getDayHour: function (hour) {
      let dayCounter = 1
      let hourCounter = hour
      if (hour > 6) {
        dayCounter = 2
        hourCounter = hour - 6
      }
      if (hour > 22) {
        dayCounter = 3
        hourCounter = hour - 22
      }
      return 'D' + dayCounter + ':H' + hourCounter
    },
    clearDeletedSubmissions: function (submissions) {
      submissions.forEach(submission => {
        if (submission.toBeDeleted) {
          this.$store.dispatch('answers/removeSubmission', submission)
        }
      })
    },
    submissionFormat: function (submission) {
      if (submission.toBeDeleted) {
        return 'answer-text-deleted'
      } else {
        return 'answer-text'
      }
    },
    hasDeletedSubmissions: function (questionNumber) {
      const submissions = this.getSubmissions(questionNumber)
      return submissions.some(submission => submission.toBeDeleted)
    },
  },
}
</script>

<style scoped lang="scss">
  .question-text {
    padding-bottom: 1rem;
    padding-left: .5rem;
  }
  .one-done {
    padding: 1rem;
    color: #7E57C2;
  }
  .ans-btn {
    display: inline-block;
    cursor: pointer;
    width: 28px;
    min-width: 20px !important;
    padding: 8px;
  }
  td, th {
    padding: 8px;
  }
  .answer-text {
    word-break: break-all;
  }
  .answer-text-deleted {
    word-break: break-all;
    text-decoration: line-through;
    color: gray;
  }
  .partial-word {
    margin-top: 16px;
  }
  .partial-title {
    margin: 10px;
  }
  .fishing-guess {
    margin-top: 20px;
  }
  .fishing-list {
    margin-top: 20px;
  }
</style>
